import { render, staticRenderFns } from "./SendSupportMessage.vue?vue&type=template&id=1668b146&scoped=true"
import script from "./SendSupportMessage.vue?vue&type=script&lang=js"
export * from "./SendSupportMessage.vue?vue&type=script&lang=js"
import style0 from "./SendSupportMessage.vue?vue&type=style&index=0&id=1668b146&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1668b146",
  null
  
)

export default component.exports